import { NgModule } from '@angular/core';
import { ReviewsEffectsModule } from './effects';

@NgModule({
  imports: [ReviewsEffectsModule],
})
export class ReviewsFeatureModule {}
